import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-copyright-dialog',
  templateUrl: './manual-copyright-dialog.component.html',
  styleUrls: ['./manual-copyright-dialog.component.css'],
  standalone: false,
})
export class ManualCopyrightDialogComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;
  readonly facilityDialogLink: string = AppConst.ROUTING_LINK_MANUAL_FACILITY_DIALOG;
  readonly projectDialogLink: string = AppConst.ROUTING_LINK_MANUAL_PROJECT_DIALOG;

  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
